import { render, staticRenderFns } from "./positionBrandManagement.vue?vue&type=template&id=78779a6a&scoped=true&"
import script from "./positionBrandManagement.vue?vue&type=script&lang=js&"
export * from "./positionBrandManagement.vue?vue&type=script&lang=js&"
import style0 from "./positionBrandManagement.vue?vue&type=style&index=0&id=78779a6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78779a6a",
  null
  
)

export default component.exports